import { Stack, useLocalSearchParams, useRouter } from 'expo-router';
import EventScorekeepingFeed from '@/components/Event/EventScorekeeping/EventScorekeepingFeed';
import EventScorekeepingFeedItem, {
  Card,
} from '@/components/Event/EventScorekeeping/EventScorekeepingFeed/EventScorekeepingFeedItem';
import Pressable from '@/components/Unistyles/Pressable';

export default function EventScorekeepingAssignment() {
  const { dismissTo } = useRouter();
  const { basePath, eventId } = useLocalSearchParams<{
    basePath?: string;
    eventId: string;
  }>();

  return (
    <>
      <Stack.Screen
        options={{
          title: 'Edit Stats',
        }}
      />
      <EventScorekeepingFeed
        renderItem={({ item }) => {
          return (
            <Card>
              <Pressable
                onPress={() => {
                  dismissTo({
                    pathname: `${basePath || '/event'}/scorekeeping`,
                    params: {
                      badgeAssigneeId: item.id,
                      eventId,
                    },
                  });
                }}
              >
                <EventScorekeepingFeedItem fragment={item.badge_assignees} />
              </Pressable>
            </Card>
          );
        }}
      />
    </>
  );
}
